
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traits/[[...slug]]",
      function () {
        return require("private-next-pages/traits/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traits/[[...slug]]"])
      });
    }
  